import "../styles/header.css";
import sebi from "../../../images/sebiLogo.webp";
import azadi from "../../../images/azadiLogo.webp";
import Marquee from "react-fast-marquee";
import { ls } from "../../../variables";

const Header = () => {
  const alertMessage=ls.get("alertMessage");
  const isUserLoggedIn=ls.get("isUserLoggedIn");
  
  return (
    <div className="header">
      <div className="headerImages">
        <img src={sebi} alt="SEBI" className="sebiFirstLogo" />
        {isUserLoggedIn && <Marquee style={{ color: "#154063", width: "68%" }}
          pauseOnHover
          delay={2}
          speed={50}
        ><div style={{whiteSpace: "pre-wrap"}}><span style={{marginLeft:"200px"}}>{alertMessage}</span></div></Marquee>}
        <img src={azadi} alt="Azadi ka amrit mahotsav" className="sebiSecondLogo" />
      </div>
    </div>
  );
};

export default Header;
